import React, { Fragment } from 'react';
import { useNavigate } from "react-router-dom";
import ListingPageComponent from '../../components/ListingPageComponent.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import UI_ACTIONS from '../../data/UiActionConstants.js';
import { getApi } from '../../api/endpoints.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import UiAction from '../../components/UiAction.js';

const Index = () => {
  const navigate = useNavigate();
  const defaultHeaderConfig = { disableSort: true };
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Mode',
      attr: 'mode',
      disableSort: true,
    },
    {
      ...defaultHeaderConfig,
      label: 'Amount',
      value: (row) => {
        return <div className="d-block">
          <div>{row.currency} {row.amount}</div>   
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'User ID',
      attr: 'user_id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
    }, 
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
    }, 
    {
      ...defaultHeaderConfig,
      label: 'TXN ID',
      attr: 'txn_id',
      disableSort: true,
    },
    // {
    //   disableSort: true,
    //   label: 'Action',
    //   value: (row) => {
    //     return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
    //       <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_addon.name)}>
    //         <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id) }>
    //           <FontAwesomeIcon icon={faEdit}/>
    //         </div>
    //       </UiAction>
    //     </div>
    //   }
    // }
  ]

  // const tableHeaderActionsComponent = () => {
  //   return <Fragment>
  //     <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_addon.name)}>
  //       <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
  //         <span>Add New Addon</span>
  //       </button>
  //     </UiAction>
  //   </Fragment>
  // }

  return <ListingPageComponent
    key={PAGES.TransactionOrdersPage.name}
    uiPage={uiManager.getUiPage(PAGES.TransactionOrdersPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'transaction_orders'}]}
    listingMutation={getApi('transaction_orders')}
    className="transaction-orders-listing-page"
    contentHeading="Transaction Orders- Results"
    headers={headers}
    recordsKey="transaction_orders"
    // tableHeaderActionsComponent={tableHeaderActionsComponent()}
    searchBy={['User Id']}
  />
};

export default Index;
